var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBoat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1355_2063)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 20,
    r: 13,
    fill: "#F2F2F2"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0003 12C22.0003 11.4469 22.4471 11 23.0003 11H27.0003C27.5534 11 28.0003 11.4469 28.0003 12V13H29.5003C30.3284 13 31.0003 13.6719 31.0003 14.5V18.5L32.3878 18.9625C33.1096 19.2031 33.3096 20.1344 32.7471 20.6469L29.5909 23.5406C29.0846 23.8344 28.5065 24.0125 28.0003 24.0125C27.3878 24.0125 26.7253 23.7719 26.1503 23.3781C25.4596 22.8938 24.5378 22.8938 23.8471 23.3781C23.3128 23.7469 22.6596 24.0125 21.9971 24.0125C21.4909 24.0125 20.9128 23.8344 20.4065 23.5406L17.2503 20.6469C16.6878 20.1313 16.8878 19.2031 17.6096 18.9625L19.0003 18.5V14.5C19.0003 13.6719 19.6721 13 20.5003 13H22.0003V12ZM21.0003 17.8344L24.369 16.7125C24.7784 16.575 25.2221 16.575 25.6346 16.7125L29.0003 17.8344V15H21.0003V17.8344ZM25.5784 24.1844C26.2815 24.6687 27.1409 25 28.0003 25C28.8409 25 29.7315 24.6625 30.419 24.1844C30.7909 23.9187 31.2971 23.9406 31.644 24.2375C32.094 24.6094 32.6596 24.8937 33.2253 25.025C33.7628 25.15 34.0971 25.6875 33.9721 26.225C33.8471 26.7625 33.3096 27.0969 32.7721 26.9719C32.0065 26.7938 31.369 26.4563 30.9534 26.1906C30.0471 26.6781 29.0315 27 28.0003 27C27.0034 27 26.1065 26.6906 25.4878 26.4094C25.3065 26.325 25.1409 26.2437 25.0003 26.1687C24.8596 26.2437 24.6971 26.3281 24.5128 26.4094C23.894 26.6906 22.9971 27 22.0003 27C20.969 27 19.9534 26.6781 19.0471 26.1938C18.6284 26.4563 17.994 26.7969 17.2284 26.975C16.6909 27.1 16.1534 26.7656 16.0284 26.2281C15.9034 25.6906 16.2378 25.1531 16.7753 25.0281C17.3409 24.8969 17.9065 24.6125 18.3565 24.2406C18.7034 23.9469 19.2096 23.925 19.5815 24.1875C20.2721 24.6625 21.1596 25 22.0003 25C22.8596 25 23.719 24.6687 24.4221 24.1844C24.769 23.9375 25.2315 23.9375 25.5784 24.1844Z",
    fill: "#132439"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1355_2063",
    x: 12,
    y: 7,
    width: 26,
    height: 27,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1355_2063"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoat);
export default __webpack_public_path__ + "static/media/boat.356cde2034941a70557d69222826a0de.svg";
export { ForwardRef as ReactComponent };